import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { NSGridModule } from '@norfolk-southern/accessns-components';

import { EBillLocationComponent } from '@ruby/modules/ebill/submodules/ebill-location/components/ebill-location.component';
import { EBillLocationContainer } from '@ruby/modules/ebill/submodules/ebill-location/containers/ebill-location.container';
import { EBillLocationRoutingModule } from '@ruby/modules/ebill/submodules/ebill-location/ebill-location-routing.module';

@NgModule({
  declarations: [EBillLocationContainer, EBillLocationComponent],
  imports: [
    CommonModule,
    NSGridModule,
    MatButtonModule,
    MatSelectModule,
    EBillLocationRoutingModule,
    FormsModule
  ],
  exports: [EBillLocationContainer]
})
export class EBillLocationModule {}
